<template>
  <Transition v-bind="props" :mode="props.mode" name="fade">
    <slot></slot>
  </Transition>
</template>
<script setup lang="ts">
import type { TransitionProps } from 'vue'

const props = defineProps<Omit<TransitionProps, 'name'>>()
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
